<template>
  <div :class="$style.detail">
    <info-card :info="info">
      <template #default="slot">
        <span v-if="slot.info.name === $t('safety.deviceStatus')"
          ><span
            :class="slot.info.content ? 'online-color' : 'offline-color'"
            >{{
              slot.info.content
                ? $t('greenConstruction.online')
                : $t('greenConstruction.offline')
            }}</span
          ></span
        >
        <span v-else>{{ slot.info.content }}</span>
      </template>
    </info-card>
    <div :class="$style.contentBox">
      <a-tabs
        :default-active-key="activeKey"
        :tabBarStyle="{ margin: '10px 20px' }"
        @change="changeTab"
      >
        <a-tab-pane
          key="rt-positioning"
          :tab="$t('peopleManagement.rtPositioning')"
        >
          <rt-positioning
            v-if="activeKey === 'rt-positioning'"
            :deviceId="data.pkId"
          />
        </a-tab-pane>
        <a-tab-pane key="trajectory" :tab="$t('peopleManagement.trajectory')">
          <trajectory v-if="activeKey === 'trajectory'" :deviceId="data.pkId" />
        </a-tab-pane>
        <a-tab-pane key="alarm-message">
          <span slot="tab">
            <a-badge
              :count="data.alarmCount"
              :number-style="{
                backgroundColor: 'var(--primary)',
                boxShadow: '0 0 0 1px var(--primary) inset',
                top: '-5px',
              }"
            >
              {{ $t('greenConstruction.alarmMessage') }}
            </a-badge>
          </span>
          <alarm-message
            v-if="activeKey === 'alarm-message'"
            :deviceId="data.pkId"
          />
        </a-tab-pane>
        <a-tab-pane
          key="binding-record"
          :tab="$t('peopleManagement.bindingRecord')"
        >
          <binding-record
            v-if="activeKey === 'binding-record'"
            :deviceId="data.pkId"
          />
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import { Component, Vue, Prop } from 'vue-property-decorator';
import AlarmMessage from './alarm-message.vue';
import BindingRecord from './binding-record.vue';
import RtPositioning from './rt-positioning.vue';
import Trajectory from './trajectory.vue';
import InfoCard from '@/views/green-construction/components/info-card.vue';

@Component({
  components: {
    AlarmMessage,
    BindingRecord,
    RtPositioning,
    Trajectory,
    InfoCard,
  },
})
export default class HelmetDetail extends Vue {
  @Prop({ type: Object, default: () => {} }) data;
  @Prop({ type: Function, default: () => {} }) close;
  get info() {
    return [
      {
        name: this.$t('safety.deviceName'),
        content: this.data.deviceName || '--',
      },
      {
        name: this.$t('safety.deviceCode'),
        content: this.data.deviceCode || '--',
      },
      {
        name: this.$t('safety.belongProject'),
        content: this.data.projectName || '--',
      },
      {
        name: this.$t('peopleManagement.bindingMember'),
        content: this.data.bindMemberVO
          ? this.data.bindMemberVO.name || '--'
          : '--',
      },
      {
        name: this.$t('common.remark'),
        content: this.data.remark || '--',
      },
      {
        name: this.$t('safety.deviceStatus'),
        content: this.data.online,
      },
    ];
  }
  activeKey = 'rt-positioning';
  changeTab(activeKey) {
    this.activeKey = activeKey;
  }
}
</script>

<style lang="less" module>
.detail {
  padding-bottom: 0;
  padding-right: 0;
  position: relative;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: calc(100vh - 75px);

  .text {
    color: var(--font-title);
  }
  .textHidden {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .contentBox {
    .boxTitle {
      font-size: 14px;
      color: var(--font);
      padding: 0 20px 10px;
    }
  }
}
</style>
